// src/components/dashboard/tiles/MLBTransactionsTile.js
import React, { useState, useEffect } from 'react';
import { dynastyTheme } from '../../../services/colorService';
import { leaguesAPI } from '../../../services/apiService';

const MLBTransactionsTile = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const result = await leaguesAPI.getMLBTransactions();
        setTransactions(result?.transactions || result || []);
      } catch (e) {
        setTransactions([]);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className={`${dynastyTheme.components.card.base} p-6`}>
      <h3 className={`text-lg font-bold ${dynastyTheme.classes.text.white} mb-4`}>
        MLB Transactions
      </h3>
      {loading ? (
        <div className="flex items-center gap-2">
          <div className="w-4 h-4 border-2 border-yellow-400 border-t-transparent rounded-full animate-spin" />
          <span className={`text-sm ${dynastyTheme.classes.text.neutralLight}`}>Loading transactions...</span>
        </div>
      ) : transactions.length === 0 ? (
        <p className={`text-sm ${dynastyTheme.classes.text.neutralLight}`}>No recent MLB transactions.</p>
      ) : (
        <div className="space-y-3 max-h-80 overflow-y-auto">
          {transactions.slice(0, 15).map((txn, i) => {
            const typeLabel = txn.typeDesc || 'Transaction';
            const isAssignment = typeLabel.toLowerCase().includes('assign');
            const isRelease = typeLabel.toLowerCase().includes('release') || typeLabel.toLowerCase().includes('dfa');
            const badgeColor = isRelease
              ? 'bg-red-500/20 text-red-400 border-red-500/30'
              : isAssignment
              ? 'bg-blue-500/20 text-blue-400 border-blue-500/30'
              : 'bg-neutral-500/20 text-neutral-400 border-neutral-500/30';

            return (
              <div key={i} className={`flex items-start gap-3 border-b ${dynastyTheme.classes.border.neutral} pb-3 last:border-0`}>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2 mb-1">
                    <span className={`text-xs px-1.5 py-0.5 rounded border font-medium flex-shrink-0 ${badgeColor}`}>
                      {typeLabel}
                    </span>
                    <span className="text-sm text-gray-400 flex-shrink-0">
                      {txn.date}
                    </span>
                  </div>
                  <p className={`text-sm ${dynastyTheme.classes.text.white}`}>
                    {txn.description}
                  </p>
                  <p className="text-sm text-gray-300 mt-0.5">
                    {txn.team}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MLBTransactionsTile;
